document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-copy-url]').forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            var url = this.getAttribute('data-copy-url');
            var tooltip = this.querySelector('.share-links__copy-tooltip');

            if (navigator.share) {
                navigator.share({ url: url }).catch(function () {});
                return;
            }

            navigator.clipboard.writeText(url).then(function () {
                if (tooltip) {
                    tooltip.textContent = tooltip.dataset.copied || 'Link copiado!';
                }
                button.classList.add('is-copied');

                setTimeout(function () {
                    if (tooltip) {
                        tooltip.textContent = '';
                    }
                    button.classList.remove('is-copied');
                }, 2000);
            });
        });
    });
});
